import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["downloadButton"];

    toggleDownloadButtonVisibility() {
        const ledgerReference = this.element.querySelector(`[id="include_ledger_reference"]`)
        const cctReference = this.element.querySelector(`[id="include_cct_reference"]`)
        const partyReference = this.element.querySelector(`[id="include_party_reference"]`)
        const notificationMessage = this.element.querySelector(`[id="reference-notification"]`)
        if (ledgerReference.checked || cctReference.checked || partyReference.checked) {
            this.downloadButtonTarget.classList.remove("hidden");
            notificationMessage.classList.remove("hidden");
        } else {
            this.downloadButtonTarget.classList.add("hidden");
            notificationMessage.classList.add("hidden");
        }
    }

    downloadButtonClick(event) {
        const ledgerReferenceValue = this.element.querySelector(`[id="include_ledger_reference"]`).checked;
        const cctReferenceValue = this.element.querySelector(`[id="include_cct_reference"]`).checked;
        const partyReferenceValue = this.element.querySelector(`[id="include_party_reference"]`).checked;
        const originalHref = event.target.href;
        const downloadUrl = `${originalHref}&include_ledger_reference=${ledgerReferenceValue}&include_cct_reference=${cctReferenceValue}&include_party_reference=${partyReferenceValue}`;
        event.preventDefault();
        Turbo.visit(downloadUrl);
        event.target.innerHTML = '<span><i data-lucide="loader-circle" class="w-4 h-4 inline animate-spin"></i></span>&nbsp;' + 'Downloading...'
        if (window.lucide) window.lucide.createIcons()
        event.target.setAttribute('disabled', true)
    }
}